var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7484 0.155833C21.9077 0.286416 22 0.481536 22 0.687506V19.9375C22 20.2652 21.7687 20.5474 21.4473 20.6117L14.5723 21.9867C14.4833 22.0045 14.3917 22.0045 14.3027 21.9867L7.5625 20.6386L0.82233 21.9867C0.620359 22.0271 0.410918 21.9748 0.251633 21.8442C0.0923471 21.7136 0 21.5185 0 21.3125V2.06251C0 1.73479 0.231316 1.45263 0.55267 1.38836L7.42767 0.0133567C7.51667 -0.00444431 7.60833 -0.00444431 7.69733 0.0133567L14.4375 1.36139L21.1777 0.0133567C21.3796 -0.0270374 21.5891 0.0252503 21.7484 0.155833ZM13.75 2.62612L8.25 1.52612V19.3739L13.75 20.4739V2.62612ZM15.125 20.4739L20.625 19.3739V1.52612L15.125 2.62612V20.4739ZM6.875 19.3739V1.52612L1.375 2.62612V20.4739L6.875 19.3739Z",
    fill: "#005182"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.38b92728cac7799abb8f76057b10ff7d.svg";
export { ForwardRef as ReactComponent };